import React from 'react';

/**
 * ConsultantApprovalButton - Godkännande-knapp för byggkonsult
 * Visas när byggkonsult vill godkänna estimat åt kunden
 * Blir inaktiv och grå om estimatet redan är godkänt
 */
const ConsultantApprovalButton = ({
  estimatData,
  submitting,
  onApprove,
}) => {
  const isApproved = 
    (estimatData?.status === 'approved') || 
    (estimatData?.customerResponse?.status === 'approved' || 
     estimatData?.customerResponse?.action === 'approved');
  const isApprovedByConsultant = estimatData?.approvedByConsultant;
  
  const isAlreadyApproved = isApproved || isApprovedByConsultant;
  const isDisabled = submitting || isAlreadyApproved;
  
  return (
    <div className="mt-4 mb-3">
      <button
        onClick={onApprove}
        disabled={isDisabled}
        className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors flex items-center gap-1.5 ${
          isAlreadyApproved
            ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
            : 'bg-green-600 hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white'
        }`}
        title={isAlreadyApproved ? 'Estimatet är redan godkänt' : undefined}
      >
        {submitting ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            Godkänner...
          </>
        ) : isAlreadyApproved ? (
          <>
            ✓ Godkänt
          </>
        ) : (
          <>
            ✓ Godkänn åt kund
          </>
        )}
      </button>
    </div>
  );
};

export default ConsultantApprovalButton;

